import { render, staticRenderFns } from "./interfer.vue?vue&type=template&id=0e1a66a3&scoped=true&"
import script from "./interfer.vue?vue&type=script&lang=js&"
export * from "./interfer.vue?vue&type=script&lang=js&"
import style0 from "./interfer.vue?vue&type=style&index=0&id=0e1a66a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1a66a3",
  null
  
)

export default component.exports